module.exports = __webpack_public_path__ + "static/media/add-friends.5dfac75e.svg";